import classes from './AttrDisplayTable.module.scss'
import DynamicFieldButtons from '../dynamic-field-multiple/DynamicFieldButtons'
import DynamicFieldMultiple from '../dynamic-field-multiple/DynamicFieldMultiple'
import AttrDisplayProps from './AttrDisplayProps'
import clsx from 'clsx'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectSkipCoDecisioning } from '../../../../../../features/createCertificate/createCertificateSlice'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { Tooltip } from 'primereact/tooltip'

export type AttrDisplayTableProps = {
  isEditCert: any
  isModifyCert: any
  hasRevisions: any
  onAddDynamicFieldMultiple: any
  onRemoveDynamicFieldMultiple: any
  setFormDisplay: any
  certifyFields: Array<string>
  decisionFields: Array<string>
  recommendFields: Array<string>
  isFieldMounted: any
  setIsFieldMounted: any
  onCopyDynamicFieldMultiple: any
  validityMessage?: any
} & AttrDisplayProps
export default function AttrDisplayTable({
  attrDisplay,
  attrIndex,
  attributeFlatList,
  certGroupIndex,
  setFormValidityMessages,
  formValidityMessages,
  setFormValues,
  setIsShowNoStandard,
  formValues,
  selectedScheme,
  isShowNoStandard,
  validityMessage,
  // extended props
  onAddDynamicFieldMultiple,
  onRemoveDynamicFieldMultiple,
  setFormDisplay,
  certifyFields,
  decisionFields,
  recommendFields,
  isEditCert,
  isModifyCert,
  hasRevisions,
  isFieldMounted,
  setIsFieldMounted,
  fieldChangeListener,
  onCopyDynamicFieldMultiple,
}: AttrDisplayTableProps) {
  const prefix = `${certGroupIndex}-${attrIndex}`
  const attributeLength = attrDisplay.attribute[0].length
  const helpText = attrDisplay.attribute
  const skipCoDecisioning = useSelector(selectSkipCoDecisioning)
  const listDecisionAttributes = decisionFields
  let slotTaken = '-x30'
  let actionHeaderSlot = '-x20'

  switch (attributeLength) {
    case 1:
      slotTaken = '-x80'
      actionHeaderSlot = '-x20'
      break
    case 2:
      slotTaken = '-x40'
      actionHeaderSlot = '-x20'
      break
    default:
      if (attributeLength >= 10) {
        let slot = Math.floor(100 / attributeLength)
        slotTaken = `-x${slot}`
        actionHeaderSlot = `-x${slot / 2}`
      }
  }

  const isButtonDisabled = () => {
    const field = attrDisplay.attribute[0].length ? attrDisplay.attribute[0][0] : null

    if (field) {
      const isCoFieldDisabled =
        skipCoDecisioning && listDecisionAttributes.includes(field.attribute_unique_name)
      return isCoFieldDisabled
    }
    return false
  }

  const getGridRowWidthSize = (): string => {
    switch (attributeLength) {
      case 4:
        return '-x77'
      case 5:
        return '-x63'
      case 6:
        return '-x50'
      case 7:
        return '-x45'
      case 8:
        return '-x38'
      case 9:
        return '-x33'
      default:
        if (attributeLength >= 10) return slotTaken
        else return ''
    }
  }
  const getActionHeaderSlot = (): string => {
    if (attributeLength > 4) return '-x20'
    else if (attributeLength >= 10) return actionHeaderSlot

    return actionHeaderSlot
  }

  return (
    <div className={clsx('dynamic-fld-card', classes['attr-display-table'])}>
      <div className={`ul-grid__row ${getGridRowWidthSize()}`}>
        {(attrDisplay.attribute[0] as any[]).map(field => (
          <div
            key={`dynamic-field-multiple-${prefix}-${field.id}`}
            className={clsx('ul-grid__column dynamic-fld-card-hdr', slotTaken)}
          >
            <span> {field.display_name}</span>
            {field.is_required && <span className="text-red"> *</span>}

            {field?.help_text != '' && (
              <span className={`tooltip-target-${field?.attribute_unique_name}`}>
                <FontAwesomeIcon
                  className={`${classes['tooltip-icon']}`}
                  icon={faQuestionCircle}
                  size="xs"
                />

                <Tooltip
                  target={`.tooltip-target-${field?.attribute_unique_name}`}
                  position="right"
                >
                  {field.help_text}
                </Tooltip>
              </span>
            )}
          </div>
        ))}
        {attrDisplay.attribute[0][0].max_value !== '1' && (
          <div className={clsx('ul-grid__column', getActionHeaderSlot, classes['action-header'])} />
        )}
      </div>

      {(attrDisplay.attribute as any[]).map((row: any[], rowIndex) => (
        <div
          className={`ul-grid__row ${getGridRowWidthSize()}`}
          key={`dynamic-field-table-row-${prefix}-${rowIndex}`}
        >
          {row.map((field, fieldIndex) => {
            const listener = fieldChangeListener
              ? fieldChangeListener[field.attribute_unique_name]
              : undefined
            const fieldValidityMessage = formValidityMessages?.[field.attribute_unique_name]
            return (
              <div
                key={`dynamic-field-table-multiple-${prefix}-${fieldIndex}`}
                className={clsx('ul-grid__column dynamic-fld-card-body', slotTaken)}
                id={`certDetails-${field.attribute_unique_name}-${rowIndex}`}
              >
                <DynamicFieldMultiple
                  setIsShowNoStandard={setIsShowNoStandard}
                  selectedScheme={selectedScheme}
                  field={field}
                  isRequired={field.is_required}
                  formValues={formValues}
                  attributeFlatList={attributeFlatList}
                  setFormValues={setFormValues}
                  setFormDisplay={setFormDisplay}
                  certGroupIndex={certGroupIndex}
                  setFormValidityMessages={setFormValidityMessages}
                  fieldIndex={fieldIndex}
                  rowIndex={rowIndex}
                  fieldType={attrDisplay.type}
                  certifyFields={certifyFields}
                  decisionFields={decisionFields}
                  recommendFields={recommendFields}
                  isEditCert={isEditCert}
                  isModifyCert={isModifyCert}
                  hasRevisions={hasRevisions}
                  isFieldMounted={isFieldMounted}
                  setIsFieldMounted={setIsFieldMounted}
                  validityMessage={fieldValidityMessage}
                  onFieldChange={(value: any) => {
                    if (listener) listener(value)
                  }}
                />
              </div>
            )
          })}
          {row[0].max_value !== '1' && (
            <>
              <DynamicFieldButtons
                className={clsx(getActionHeaderSlot, 'dynamic-fld-action-btn')}
                setIsShowNoStandard={isShowNoStandard}
                rowIndex={rowIndex}
                rowLength={attrDisplay.attribute.length}
                onAddDynamicFieldMultiple={() => {
                  if (isButtonDisabled()) return
                  onAddDynamicFieldMultiple(certGroupIndex, attrIndex, row)
                }}
                onRemoveDynamicFieldMultiple={() => {
                  if (isButtonDisabled()) return
                  onRemoveDynamicFieldMultiple(row[0].id, certGroupIndex, attrIndex, rowIndex, row)
                }}
                onCopyDynamicFieldValue={() =>
                  onCopyDynamicFieldMultiple(certGroupIndex, attrIndex, row, rowIndex)
                }
                fieldName={row[0].attribute_unique_name}
                certGroupIndex={certGroupIndex}
              />
            </>
          )}
        </div>
      ))}
    </div>
  )
}
